import React, { useEffect } from 'react'
import { navigate, RouteComponentProps, useParams } from '@reach/router'
import addScript from 'utils/addScript'
import removeSession from 'utils/removeSession'
import useFetchLogin from './useFetchLogin'
import Container from '@mui/material/Container'
import Footer from 'components/footer/footer'
import Functioning from './components/functioning/functioning'
import './index.css'



const Loader = React.lazy(() => import('assets/theme/components/Loader'))
const Benefits = React.lazy(() => import('.//components/benefits/benefits'))
const PichinchaLogin = React.lazy(() => import('./components/pichinchaLogin/pichinchaLogin'))
const Simulator = React.lazy(() => import('./components/simulator'))
const Carousel = React.lazy(() => import('./components/carousel/carousel'))
const Buttonloan = React.lazy(() => import('./components/buttonLoan/buttonloan'))
const Doubt = React.lazy(() => import('./components/doubt/doubt'))
const Comments = React.lazy(() => import('./components/comments/comments'))

const Login: React.FC<RouteComponentProps> = (): any => {

  const { flujo, adviser } = useParams()
  
  // Remover token de otros flujos
  sessionStorage.removeItem('token')
  useEffect(() => {
    if (flujo === 'autogestion' && adviser) {
      navigate('/autogestion/login')
    }
    removeSession()
  }, [adviser, flujo])

  useEffect(() => {
    try {
      const evergage = (window as any).Evergage
      if (evergage) {
        const user = evergage.getState().result.currentPage.user
        evergage.sendEvent({ action: `Flujo_Credito_Landing_00Login_Page_View_None`, user })
      }
    } catch (e) {
      console.log(e)
    }
    
  }, [])

  const { error, loader } = useFetchLogin(flujo)
  // Agregar Script
  addScript()

  const DoubtMeno = React.useMemo(() => <Doubt />, [])
  const FunctioningMemo = React.useMemo(() => <Functioning />, [])
  const SimulatorMemo = React.useMemo(() => <Simulator />, [])
  const CommentsMeno = React.useMemo(() => <Comments />, [])
  const CarouselMemo = React.useMemo(() => <Carousel />, [])
  const BenefitsMemo = React.useMemo(() => <Benefits />, [])
  const ButtonloanMemo = React.useMemo(() => <Buttonloan />, [])
  const PichinchaLoginMeno = React.useMemo(() => <PichinchaLogin error={error} adviser={adviser} flujo={flujo} />, [error, adviser, flujo])

  if (loader) {
    return <Loader />
  }

  return (
    <>
      <Container maxWidth={false} className="bp-p-0 container">
        <React.Suspense fallback={<Loader />}>
          {PichinchaLoginMeno}
          {BenefitsMemo}
          {SimulatorMemo}
          {FunctioningMemo}
          {CommentsMeno}
          {CarouselMemo}
          {DoubtMeno}
          {ButtonloanMemo}
        </React.Suspense>
      </Container>
      <Footer />
    </>
  )
}

export default Login

